export const CurrencyIcon = ({ primaryFontColor = "#ffd800" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      min-width="24px"
      height="24px"
      viewBox="0 0 15.572 15.572"
    >
      <path
        id="rupee-symbol"
        d="M9.286,1.5a7.786,7.786,0,1,0,7.786,7.786A7.786,7.786,0,0,0,9.286,1.5ZM10.843,7h.373a.519.519,0,0,1,0,1.038h-.247a2.463,2.463,0,0,1-2.448,2.226H8.356l1.975,2.083a.519.519,0,1,1-.753.714L6.772,10.106a.519.519,0,0,1,.377-.876H8.521a1.421,1.421,0,0,0,1.4-1.188H7.171A.519.519,0,1,1,7.171,7H9.693a1.419,1.419,0,0,0-1.171-.617H7.15a.519.519,0,1,1,0-1.038H8.523l.057,0h2.639a.519.519,0,0,1,0,1.038h-.689A2.455,2.455,0,0,1,10.845,7Z"
        transform="translate(-1.5 -1.5)"
      />
    </svg>
  );
};
